// extracted by mini-css-extract-plugin
export default {"container":"Fp-z","heading":"Gp-z","text":"Hp-z","info":"Ip-z","link":"Jp-z","fullMaxWidth":"Kp-z"};